<template>
  <div class="bg" style="background: url(static/img/background.jpg)">
    <v-container grid-list-lg class="mb-5 responsive-container">
      <v-layout row justify-center wrap>
        <BackSimulator></BackSimulator>
        <v-flex xs12 md6 lg4>
          <img src="static/logo/logo.svg" width="60%" class="mx-auto mt-2" />
        </v-flex>
        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">Dados Pessoais</h1>
        </v-flex>
        <v-flex xs12 class="mb-4">
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Nome *</p>
                    <v-text-field
                      ref="nome"
                      solo
                      hide-details
                      v-model="form.nome"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.telefone.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Telefone *</p>
                    <v-text-field
                      ref="telefone"
                      type="tel"
                      inputmode="tel"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                      v-model="form.telefone"
                      placeholder="(00) 00000-0000"
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.email.focus()"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">E-mail *</p>
                    <v-text-field
                      ref="email"
                      type="email"
                      solo
                      hide-details
                      v-model="form.email"
                      :error="emailError"
                      :error-messages="emailError ? ['E-mail inválido'] : []"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.empresa.focus()"
                      @blur="validateEmail"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Empresa (Razão Social) *</p>
                    <v-text-field
                      ref="empresa"
                      solo
                      hide-details
                      v-model="form.empresa"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.cargo.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Cargo *</p>
                    <v-text-field
                      ref="cargo"
                      solo
                      hide-details
                      v-model="form.cargo"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.custo.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">
            Formulário de Ar Comprimido
          </h1>
        </v-flex>
        <v-flex xs12>
          <v-card class="card-custom mb-2">
            <v-card-text class="card-custom-text">
              <v-container fluid>
                <v-layout row wrap align-end>
                  <!-- <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">
                      Temperatura Média do Local (°C) *
                    </p>
                    <v-text-field
                      ref="custo"
                      solo
                      value="25"
                      v-money="money0"
                      inputmode="decimal"
                      :attrs="{ returnKeyType: 'next' }"
                      append-icon="mdi mdi-thermometer"
                      @keyup.enter="
                        $refs.quantidade && $refs.quantidade.focus()
                      "
                      v-model="form.temperatura"
                    />
                    <small>&nbsp;</small>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Altitude do local (m) *</p>
                    <v-text-field
                      ref="custo"
                      value="450"
                      v-money="money0"
                      solo
                      append-icon="mdi mdi-elevation-rise"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="
                        $refs.quantidade && $refs.quantidade.focus()
                      "
                      v-model="form.altitude"
                    />
                    <small>&nbsp;</small>
                  </v-flex> -->
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Custo da Energia (R$/MWh) *</p>
                    <v-text-field
                      ref="custo"
                      v-model="form.custo"
                      v-money="money"
                      solo
                      inputmode="decimal"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="
                        $refs.quantidade && $refs.quantidade.focus()
                      "
                    />
                    <small>(Energia + Encargos + Impostos)</small>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          v-for="(item, index) in equipamentos"
          :key="index"
          class="mb-4"
        >
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 class="pt-2">
                    <div class="compressor-card-title">
                      <p
                        class="primary--text text-uppercase font-weight-bold mb-0"
                      >
                        Compressor {{ index + 1 }}
                      </p>
                      <v-tooltip top v-if="index !== 0">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="ml-auto mr-0"
                            v-on="on"
                            @click="removeCard(index)"
                          >
                            <v-icon>mdi mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover</span>
                      </v-tooltip>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 md4 lg2 class="text-xs-left">
                    <p class="caption mb-2">Dias Operação/Mês *</p>
                    <!-- <v-text-field
                      ref="dias_mes"
                      type="text"
                      inputmode="numeric"
                      v-model="item.dias_operacao_mes"
                      v-mask="'##'"
                      placeholder="Ex.: 30"
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                      @blur="validateDiasMes(item)"
                    /> -->
                    <v-select
                      ref="dias_mes"
                      v-model="item.dias_operacao_mes"
                      solo
                      hide-details
                      :items="dias_mes"
                      @change="validateDiasMes(item)"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg2 class="text-xs-left">
                    <p class="caption mb-2">Horas de Operação/Dia *</p>
                    <!-- <v-text-field
                      ref="horas"
                      type="text"
                      inputmode="numeric"
                      v-model="item.horas_operacao_dia"
                      v-mask="'##'"
                      placeholder="Ex.: 24"
                      solo
                      hide-details
                      append-icon="mdi mdi-timer"
                      :attrs="{ returnKeyType: 'next' }"
                      @blur="validateHours(item)"
                    /> -->
                    <v-select
                      ref="horas"
                      v-model="item.horas_operacao_dia"
                      solo
                      hide-details
                      :items="horas_dias"
                      @change="validateHours(item)"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg2 class="text-xs-left">
                    <p class="caption mb-2">Quantidade *</p>
                    <v-text-field
                      ref="quantidade"
                      type="text"
                      inputmode="numeric"
                      v-model="item.quantidade"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>

                  <v-flex xs12 sm6 md6 lg3 class="text-xs-left">
                    <p class="caption mb-2">Tipo dos Compressores *</p>
                    <v-select
                      ref="tipo_compressores"
                      v-model="item.tipo_compressores"
                      :items="compressorTypes"
                      solo
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Ano Fabricação *</p>
                    <v-text-field
                      ref="ano_fabricacao"
                      type="text"
                      inputmode="numeric"
                      v-model="item.ano_fabricacao"
                      v-mask="'####'"
                      placeholder="Ex.: 2010"
                      @blur="validateYear(item)"
                      solo
                      hide-details
                      append-icon="mdi mdi-calendar"
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Capacidade Nominal (m³/h) *</p>
                    <v-text-field
                      ref="capacidade_nominal"
                      type="text"
                      inputmode="numeric"
                      v-model="item.capacidade_nominal_m3_h"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Potência Nominal (kW) *</p>
                    <v-text-field
                      ref="potencia_nominal"
                      type="tel"
                      inputmode="numeric"
                      v-model="item.potencia_nominal_kw"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      append-icon="mdi mdi-flash"
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Pressão Nominal (bar g) *</p>
                    <v-text-field
                      ref="pressao_nominal"
                      type="text"
                      inputmode="decimal"
                      v-model="item.pressao_nominal_bar_g"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9.,]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9.,]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Pressão de Trabalho (bar g) *</p>
                    <v-text-field
                      ref="pressao_trabalho"
                      type="text"
                      inputmode="decimal"
                      v-model="item.pressao_trabalho_bar_g"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9.,]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9.,]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      placeholder="Ex.: 7,00"
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">
                      Fator de Carga Médio (0 a 100%) *
                    </p>
                    <v-text-field
                      ref="fator_carga"
                      type="text"
                      inputmode="numeric"
                      v-model="item.fator_carga_medio"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9]/.test(text)) e.preventDefault();
                        }
                      "
                      @blur="
                        validatePocentagem(
                          item,
                          'fator_carga_medio',
                          'Fator de Carga Médio'
                        )
                      "
                      solo
                      hide-details
                      append-icon="mdi mdi-percent"
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">
                      Percentual de tempo em Carga (0 a 100%) *
                    </p>
                    <v-text-field
                      ref="percentual_carga"
                      type="text"
                      inputmode="numeric"
                      v-model="item.percentual_tempo_carga"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9]/.test(text)) e.preventDefault();
                        }
                      "
                      @blur="
                        validatePocentagem(
                          item,
                          'percentual_tempo_carga',
                          'Percentual de tempo em Carga'
                        )
                      "
                      solo
                      hide-details
                      append-icon="mdi mdi-percent"
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Tensão de Operação (V) *</p>
                    <v-text-field
                      ref="tensao_operacao"
                      type="text"
                      inputmode="numeric"
                      v-model="item.tensao_operacao_v"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      append-icon="mdi mdi-flash"
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Regime de Funcionamento *</p>
                    <v-select
                      ref="regime_funcionamento"
                      v-model="item.regime_funcionamento"
                      :items="regimeOptions"
                      solo
                      hide-details
                    />
                  </v-flex>

                  <v-flex xs12 class="text-xs-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          color="primary"
                          class="ml-auto mr-1"
                          v-on="on"
                          @click="addCard"
                        >
                          <v-icon>mdi mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="text-xs-right pb-5">
          <v-btn color="primary" @click="sendForm()">
            Enviar dados
            <v-icon right>mdi mdi-send</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
let _base;

try {
  _base = require("@/page/_base.vue").default;
} catch (err) {
  _base = require("@/framework/page/_base.vue").default;
}

import { VMoney } from "v-money";

import BackSimulator from "@/page/widget/backSimulator.vue";

import Swal from "sweetalert2";
import { mask } from "vue-the-mask";
export default {
  extends: _base,

  data() {
    return {
      dias_mes: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      horas_dias: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24,
      ],
      dias_semana: [1, 2, 3, 4, 5, 6, 7],
      mode: "Vazão",
      id_mode: 0,
      form: {
        nome: "",
        telefone: "",
        email: "",
        empresa: "",
        cargo: "",
        custo: 0,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 2,
        masked: false,
      },
      money0: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 0,
        masked: false,
      },
      emailError: false,
      equipamentos: [
        {
          dias_operacao_mes: "",
          horas_operacao_dia: "",
          quantidade: "",
          tipo_compressores: "",
          ano_fabricacao: "",
          capacidade_nominal_m3_h: "",
          potencia_nominal_kw: "",
          pressao_nominal_bar_g: "",
          pressao_trabalho_bar_g: "",
          fator_carga_medio: "",
          percentual_tempo_carga: "",
          tensao_operacao_v: "",
          regime_funcionamento: "",
          ano_fabricacao_error: "",
          horas_operacao_dia_error: "",
          dias_operacao_mes_error: false,
        },
      ],
      endpoint: global.config.endpoint,
      compressorTypes: [
        "Parafuso",
        "Parafuso Lubrificado",
        "Parafuso Lubrificado Com Variador de Frequência",
        "Parafuso Com Variador de Frequência",
        "Pistão",
        "Centrífugo",
      ],
      regimeOptions: ["Principal", "Backup"],
    };
  },
  mounted() {
    // Check for mode in URL query params and override this.mode if valid
    // console.log(this.$route);
    // this.$router.go(-1);
    const urlMode =
      this.$route && this.$route.query ? this.$route.query.mode : null;

    if (urlMode === "vazao") {
      this.mode = "Vazão";
      this.id_mode = 0;
    }

    if (urlMode === "valvula") {
      this.mode = "Válvula";
      this.id_mode = 1;
    }

    // const saved = localStorage.getItem("iluminacao_form");
    // if (saved) {
    //   const parsed = JSON.parse(saved);
    //   this.form = parsed.form || this.form;
    //   this.equipamentos = parsed.equipamentos || this.equipamentos;
    // }
  },
  methods: {
    retorna() {
      this.$router.back();
      // Equivalente a: this.$router.go(-1);
    },
    validatePocentagem(item, campo, title) {
      if (item[campo] > 100) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>" +
            title +
            "</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                O valor não pode ultrapassar 100%</b>.
              </p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      }
    },
    validateYear(item) {
      const year = Number(item.ano_fabricacao);
      const currentYear = new Date().getFullYear();

      if (year < 1821 || year > currentYear) {
        item.ano_fabricacao = "";
        item.ano_fabricacao_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Ano de Fabricação</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1821</b> e <b style="font-weight: bold !important;">${currentYear}</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.ano_fabricacao_error = false;
      }
    },
    validateHours(item) {
      const horas = Number(item.horas_operacao_dia);

      if (!horas || horas <= 0 || horas > 24) {
        item.horas_operacao_dia = "";
        item.horas_operacao_dia_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Horas de Operação por Dia</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1</b> e <b style="font-weight: bold !important;">24</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.horas_operacao_dia_error = false;
      }
    },
    validateDiasMes(item) {
      const dias = Number(item.dias_operacao_mes);

      if (!dias || dias <= 0 || dias > 31) {
        item.dias_operacao_mes = "";
        item.dias_operacao_mes_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Dias de Operação no Mês</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1</b> e <b style="font-weight: bold !important;">31</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.dias_operacao_mes_error = false;
      }
    },
    async sendForm() {
      let error = "";

      if (this.validaequipamentos()) {
        error = "Preencha todos os campos dos equipamentos!";
      }

      if (this.emailError) {
        error = "Por favor, informe um e-mail válido";
      }

      if (this.form.custo == "") {
        error = "Informe o custo da energia";
      }

      if (this.form.cargo == "") {
        error = "Informe o cargo";
      }

      if (this.form.empresa == "") {
        error = "Informe a razão social";
      }

      if (this.form.email == "") {
        error = "Inserir o e-mail";
      }

      if (this.form.telefone == "") {
        error = "Informe o telefone";
      }
      if (this.form.nome == "") {
        error = "Informa o nome";
      }

      if (error != "") {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                       ${error}
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      if (this.equipamentos && this.equipamentos.length > 10) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Limite de equipamentes é 10</strong>",
          confirmButtonText: "Ok",
        });

        return;
      }

      const formData = {
        form: this.form,
        equipamentos: this.equipamentos,
        id_mode: this.id_mode,
      };

      // console.log("Dados a serem enviados:", formData);
      // Swal.fire({
      //   icon: "success",
      //   title:
      //     "<strong style='font-size: 20px !important;'>Formulário enviado!</strong>",
      //   html: `
      //         <div style="padding: 10px;">
      //             <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
      //                    Seu formulário foi enviado com sucesso!
      //               </p>
      //           </div>
      //       `,
      //   confirmButtonText: "Ok",
      // });
      Swal.showLoading();
      let valores = JSON.stringify(formData);

      let res = await this.callLocalAction("save_estudo", {
        dados: valores,
      });

      if (res && res.ok && res.ok.ok) {
        Swal.fire({
          icon: "success",
          title:
            "<strong style='font-size: 20px !important;'>Resultado enviado</strong>",
          html: `
              <div style="padding: 10px;">
                  <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                    O resultado da simulação foi enviado para o e-mail informado: <b>${this.form.email}</b>
                  </p>
                </div>
            `,
          confirmButtonText: "Ok",
          confirmButtonColor: "#68b842",
        }).then(async () => {
          this.retorna();
        });
      } else {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Erro ao salvar</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Não foi possível realizar o estudo
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }
    },
    validaequipamentos() {
      const requiredFields = [
        "dias_operacao_mes",
        "horas_operacao_dia",
        "quantidade",
        "tipo_compressores",
        "ano_fabricacao",
        "capacidade_nominal_m3_h",
        "potencia_nominal_kw",
        "pressao_nominal_bar_g",
        "pressao_trabalho_bar_g",
        "fator_carga_medio",
        "percentual_tempo_carga",
        "tensao_operacao_v",
        "regime_funcionamento",
      ];

      for (let i = 0; i < this.equipamentos.length; i++) {
        const instalacao = this.equipamentos[i];

        if (requiredFields.some((field) => instalacao[field] === "")) {
          return true; // encontrou campo inválido
        }
      }

      return false;
    },
    maskTelefone() {
      let v = this.form.telefone.replace(/\D/g, "");

      if (v.length > 11) v = v.slice(0, 11);

      if (v.length > 10) {
        v = v.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
      } else if (v.length > 6) {
        v = v.replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
      } else if (v.length > 2) {
        v = v.replace(/^(\d{2})(\d{0,5})$/, "($1) $2");
      } else {
        v = v.replace(/^(\d*)$/, "($1");
      }

      this.form.telefone = v;
      this.saveLocal();
    },

    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !regex.test(this.form.email);
      this.saveLocal();
    },

    saveLocal() {
      // localStorage.setItem(
      //   "iluminacao_form",
      //   JSON.stringify({
      //     form: this.form,
      //     equipamentos: this.equipamentos,
      //   })
      // );
    },

    addCard() {
      this.equipamentos.push({
        dias_operacao_mes: "",
        horas_operacao_dia: "",
        quantidade: "",
        tipo_compressores: "Parafuso Lubrificado",
        ano_fabricacao: "",
        capacidade_nominal_m3_h: "",
        potencia_nominal_kw: "",
        pressao_nominal_bar_g: "",
        pressao_trabalho_bar_g: "",
        fator_carga_medio: "",
        percentual_tempo_carga: "",
        tensao_operacao_v: "",
        regime_funcionamento: "Backup",
        ano_fabricacao_error: "",
        horas_operacao_dia_error: "",
        dias_operacao_mes_error: false,
      });
      this.saveLocal();
    },
    removeCard(index) {
      if (this.equipamentos.length === 1) return;

      this.equipamentos.splice(index, 1);
      this.saveLocal();
    },
  },
  directives: {
    money: VMoney,
    mask,
  },
  components: {
    BackSimulator,
  },
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

.bg {
  min-height: 100svh;
  min-width: 100svw;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
}

.card-custom {
  backdrop-filter: blur(6px) brightness(0.8) !important;
  background: tint($body-color, 70%);
  border: 1px solid tint($brand-primary, 90%) !important;
  border-radius: 2.4rem !important;
  margin-bottom: -16px;

  .card-custom-text {
    padding: 16px !important;

    @media (min-width: 960px) {
      padding: 16px 16px 16px 16px !important;
    }
  }
}

.v-select__selection.v-select__selection--comma,
.v-input {
  font-size: 14px !important;
}

.v-text-field__details {
  display: none !important;
}

.primary {
  background-color: $brand-default !important;
  border-color: $brand-default !important;
}

.v-text-field input[type="number"]::-webkit-inner-spin-button,
.v-text-field input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.v-text-field input[type="number"] {
  -moz-appearance: textfield;
}

.responsive-container {
  max-width: 1264px; // padrão lg do Vuetify
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 960px) {
    max-width: 100%;
  }
}

.compressor-card-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-plus {
  margin-top: 32px;
}
</style>
